import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));

export function StadiumRoutes() {
  return (
    <Routes>
      <Route path={Pages.sports.stadium.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.sports.stadium.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.sports.stadium.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.sports.stadium.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.sports.stadium.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.sports.stadium.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
